import React from "react";
import TYPES from "./constants";

import Label from "./label/label.component";
import Checkbox from "./checkbox/checkbox.component";
import Radio from "./radio/radio.component";
import Number from "./number/number.component";
import NumberLabeled from "./numberLabeled/numberLabeled.component";
import SimpleText from "./simpleText/simpleText.component";
import SimpleLabeledText from "./simpleLabeledText/simpleLabeledText.component";
import SelectLabeled from "./selectLabeled/selectLabeled.component";
import Select from "./select/select.component";
import Ranking from "./ranking/ranking.component";
import SimpleTextArea from "./simpleTextArea/simpleTextArea.component";
import RichText from "./richText/richText.component";
import File from "./file/file.component";
import Date from "./date/date.component";
import DateTime from "./datetime/datetime.component";
import Location from "./location/location.component";
import JsonEditorReact from "./jsonEditorReact/editorWrapper";
import Hidden from "./hidden/hidden.component";
import Color from "./color/color.component";
import BooleanRadio from "./booleanRadio/booleanRadio.component";

const GenericInputField = ({ type, ...props }) => {
  switch (type) {
    case TYPES.CHECKBOX:
      return <Checkbox {...props} />;
    case TYPES.COLOR:
      return <Color {...props} />;
    case TYPES.RADIO:
      return <Radio {...props} />;
    case TYPES.BOOLEAN_RADIO:
      return <BooleanRadio {...props} />;
    case TYPES.NUMBER:
      return <Number {...props} />;
    case TYPES.NUMBER_LABELED:
      return <NumberLabeled {...props} />;
    case TYPES.SIMPLE_TEXT:
      return <SimpleText {...props} />;
    case TYPES.SIMPLE_LABELED_TEXT:
      return <SimpleLabeledText {...props} />;
    case TYPES.SELECT:
      return <Select {...props} />;
    case TYPES.SELECT_LABELED:
      return <SelectLabeled {...props} />;
    case TYPES.RANKING:
      return <Ranking {...props} />;
    case TYPES.SIMPLE_TEXTAREA:
      return <SimpleTextArea {...props} />;
    case TYPES.TEXTAREA:
      return <RichText {...props} />;
    case TYPES.FILE:
      return <File {...props} />;
    case TYPES.DATE:
      return <Date {...props} />;
    case TYPES.DATETIME:
      return <DateTime {...props} />;
    case TYPES.LOCATION:
      return <Location {...props} />;
    case TYPES.JSON_FIELD:
      return <JsonEditorReact {...props} />;
    case TYPES.HIDDEN:
      return <Hidden {...props} />;
    default:
      return <SimpleText {...props} />;
  }
};

export { TYPES, Label };
export default GenericInputField;
